/**
 * The Truthful and Accurate certification and its signature lines, shared by the 510(k), De Novo and PMA
 * pages (EstarRenderer, DeNovoRenderer, PmaRenderer). Siblings: DossierPrimitives (Placeholder,
 * withInlinePlaceholders); the Word file prints the same lines (backend/services/vault_docx/us_device/shared.py
 * `_certification`), and tests/test_us_device_certification_block.py holds these hints and prefixes equal to
 * app/dossier/usa/rules/page_items.py.
 */
import { Placeholder, withInlinePlaceholders } from './DossierPrimitives';

// The submitter's to-dos (page_items.py): nothing is signed, named or dated until the submitter does it.
const TRUTHFUL_STATEMENT_HINT = 'Statement of certification';
const SIGNATURE_HINT = 'Electronic signature';
const SIGNATORY_NAME_HINT = 'Signatory name';
const SIGNATORY_TITLE_HINT = 'Signatory title';
const SIGNATURE_DATE_HINT = 'Date';

/** A saved value, or the to-do marker `withInlinePlaceholders` draws as the submitter's to-do. */
function valueOrToDo(value: unknown, hint: string): string {
  return typeof value === 'string' && value !== '' ? value : `__PLACEHOLDER__:${hint}`;
}

export function TruthfulAccurateBlock({ tas }: { tas: Record<string, unknown> }) {
  const statement = typeof tas.statement === 'string' ? tas.statement : '';
  return (
    <div className="text-[13.5px] leading-[1.6]">
      <p className="m-0 my-1">
        {statement ? withInlinePlaceholders(statement) : <Placeholder hint={TRUTHFUL_STATEMENT_HINT} />}
      </p>
      <p className="m-0 my-1">&nbsp;</p>
      <p className="m-0 my-1">
        <Placeholder hint={SIGNATURE_HINT} />
      </p>
      <p className="m-0 my-1">
        {withInlinePlaceholders(`Name: ${valueOrToDo(tas.signatory_name, SIGNATORY_NAME_HINT)}`)}
      </p>
      <p className="m-0 my-1">
        {withInlinePlaceholders(`Title: ${valueOrToDo(tas.signatory_title, SIGNATORY_TITLE_HINT)}`)}
      </p>
      <p className="m-0 my-1">
        {withInlinePlaceholders(`Date: ${valueOrToDo(tas.date, SIGNATURE_DATE_HINT)}`)}
      </p>
    </div>
  );
}
